import React, {useEffect, useState, useRef} from 'react';
import {withStyles} from '@material-ui/core/styles';
import CheckBox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import classes from './FilterPanel.module.css';
import {buildFilterLabel} from '../../helpers/buildFilterLabel';
import KendoFilterGridModal from './KendoFilterGridModal';
import clsx from 'clsx';
import HtmlTooltip from '../../components/HtmlTooltip/HtmlTooltip';

const FilterCheckbox = withStyles({
    root: {
        color:      '#000',
        '&checked': {
            color: '#000'
        }
    },
    checked: {}
})((props) => <CheckBox color="default" {...props} />);

const FilterPanel = props => {
    const filterTextRef = useRef();
    const {columns, fields, filter, setFilter, title, filterText, setFilterText} = props;

    const [filterModalOpen, setFilterModalOpen] = useState(false);
    const [appliedFilter, setAppliedFilter] = useState(filter);
    const [showAppliedFilter, setShowAppliedFilter] = useState(true);
    const [showOverflow, setShowOverflow] = useState(false);

    const onFilterClick = event => {
        setFilterModalOpen(!filterModalOpen);
    };

    const onApplyFilterChange = event => {
        if (event.target.checked) {
            setFilter(appliedFilter);
        }
        else {
            setFilter(undefined);
        }
        setShowAppliedFilter(event.target.checked);
    };

    const onClearFilter = () => {
        setFilter(null);
        setAppliedFilter(null);
    };

    useEffect(() => {
        setShowOverflow(filterTextRef.current.scrollWidth > filterTextRef.current.clientWidth);
    }, [filterText]);

    useEffect(() => {
        if (filter === undefined && !showAppliedFilter && appliedFilter !== undefined && appliedFilter?.filters.length > 0) {
            setFilterText(buildFilterLabel(appliedFilter, fields));
        }
        else {
            setFilterText(buildFilterLabel(filter, fields));
            setShowAppliedFilter(filter && filter.filters?.length > 0);
        }
    }, [filter, fields, setFilterText]);

    if (fields) {
        return (
            <div className={classes.FilterPanel}>
                <div className={classes.FilterDisplay}>
                    <div className={classes.FilterSection}>
                        <div className={classes.FilterCheckbox}>
                            <FilterCheckbox
                                checked={showAppliedFilter}
                                onChange={onApplyFilterChange}
                                disableRipple
                                disableFocusRipple
                                classes={{
                                    root:    classes.CheckBox,
                                    checked: classes.CheckedCheckBox
                                }}
                            />
                        </div>
                        <div className={classes.FilterIcon}>
                            <span role="none" className={clsx('material-icons', classes.filterIcon)} onClick={onFilterClick}>filter_alt</span>
                        </div>
                        <div className={classes.AppliedFilterText}>
                            <span
                                role="none"
                                
                                className={classes.filterText}
                                onClick={onFilterClick}
                            >
                                <HtmlTooltip
                                    information={filterText}
                                    placement={'top'}
                                    body={
                                        <div ref={filterTextRef} className={classes.filterText}>
                                            {filterText}
                                        </div>
                                    }
                                    disableHoverStatus={!showOverflow}
                                />
                            </span>
                        </div>
                    </div>
                </div>
                <div className={classes.ClearColumn}>
                    <Button
                        className={classes.Button}
                        onClick={onClearFilter}
                        disableRipple
                    >
                        Clear
                    </Button>
                </div>
                {filterModalOpen ?
                    <KendoFilterGridModal
                        title={title}
                        filterModalOpen={filterModalOpen}
                        setFilterModalOpen={setFilterModalOpen}
                        columns={columns}
                        fields={fields}
                        filter={appliedFilter}
                        setFilter={setFilter}
                        setAppliedFilter={setAppliedFilter}
                    />
                    : null}
            </div>
        );
    }
    else {
        return null;
    }
};

export default (FilterPanel);
